import {connectionProviderMatches} from "@app/shared/connection-provider";
// Authenticated continuation metadata; never credentials, input or an installation grant.
import {uuid,publicToken} from './model';
export type OAuthRequest = <T>(path: string, options?: RequestInit) => Promise<T>;
export interface OAuthRead {
 status: 'pending'|'claimed'|'completed'|'expired'|'failed';
 activationAttemptId: string; intentId: string; requirementId: string;
 provider: string; connectionId: string|null; pendingConnectionId: string|null; expiresAt: string;
}
export interface ConnectResponse {mode:'oauth'|'composio';authorizeUrl:string|null;entryNonce:string;connectionId?:string;}
export interface ExternalWindow {open:(url:string)=>boolean;close:()=>void;}
export function httpsAuthorizationUrl(value: unknown): string|null {
 try { if(typeof value!=='string'||value.length>16000)return null; const u=new URL(value);return u.protocol==='https:'&&!u.username&&!u.password?u.toString():null; }catch{return null;}
}
export function connectionMatches(provider: string, options: string[]): boolean {
 return options.some(option=>connectionProviderMatches(option,provider));
}
export async function readEntryOAuth(request: OAuthRequest, nonce: string): Promise<OAuthRead> {
 if(!publicToken.test(nonce))throw Error('invalid_continuation');
 const validate=(v:OAuthRead)=>{
  if(!uuid.test(v.activationAttemptId)||!uuid.test(v.intentId)||!Number.isFinite(Date.parse(v.expiresAt)))throw Error('invalid_continuation');
  if(v.status==='completed'&&(!v.connectionId||!uuid.test(v.connectionId)))throw Error('invalid_connection');
  return v;
 };
 let value=validate(await request<OAuthRead>(`/api/marketplace/entry-oauth/${nonce}`));
 if(value.status==='pending'&&value.pendingConnectionId){
  if(!uuid.test(value.pendingConnectionId)||!/^[A-Za-z0-9_-]{1,64}$/.test(value.provider))throw Error('invalid_continuation');
  try {await request(`/api/integrations/connect/${value.provider}/status?connectionId=${value.pendingConnectionId}&entryNonce=${nonce}`);}
  catch { /* Concurrent callback may have consumed the nonce. Read authoritative state, never restart OAuth. */ }
  value=validate(await request<OAuthRead>(`/api/marketplace/entry-oauth/${nonce}`));
 }
 return value;
}
export function createBrowserWindow(): ExternalWindow {
 let page:Window|null=null;
 try{page=window.open('about:blank','_blank');}catch{/* Browser may block popups; keep the explicit link fallback. */}
 return {open:(url)=>{try{if(!page||page.closed)return false;page.opener=null;page.location.replace(url);return true;}catch{return false;}},close:()=>{try{if(page&&!page.closed)page.close();}catch{/* Only our optional popup is affected. */}}};
}
